import { numeric, sum } from './dashboardMetrics.js';
export function overheadProcesses(lines) {
  const found = new Map();
  for (const line of lines.filter((r) => r.cost_source === 'alfatex')) {
    for (const process of (line.process_costs || []).filter((p) => p.is_overhead === true)) found.set(process.id, process);
  }
  return [...found.values()].sort((a,b) => String(a.description).localeCompare(String(b.description)));
}
export function overheadSummary(lines) {
  const alfatex = lines.filter((r) => r.cost_source === 'alfatex');
  const included = alfatex.filter((r) => Array.isArray(r.process_costs) && r.quantity != null && r.cost != null);
  const excludedArt = lines.filter((r) => r.cost_source === 'art');
  const includedSet = new Set(included);
  const excludedOther = lines.filter((r) => !includedSet.has(r) && r.cost_source !== 'art');
  const rows = included.map((line) => {
    const marked = line.process_costs.filter((p) => p.is_overhead === true);
    const overheadUnit = sum(marked, 'unit_cost');
    return { ...line, overheadUnit, overhead: numeric(line.quantity) * overheadUnit, hasOverhead: marked.length > 0 };
  });
  const months = [...new Set(rows.map((r) => r.date.slice(0,7)))].sort().map((month) => {
    const scope = rows.filter((r) => r.date.startsWith(month));
    return { month, revenue: sum(scope,'revenue'), cost: sum(scope,'cost'), overhead: sum(scope,'overhead') };
  });
  const articles = (scope) => new Set(scope.map((r) => String(r.code || '').trim()).filter(Boolean)).size;
  return { rows, months, excludedArt, excludedOther, articles: articles(rows), artArticles: articles(excludedArt), otherArticles: articles(excludedOther),
    overhead: sum(rows,'overhead'), cost: sum(rows,'cost'), revenue: sum(rows,'revenue'), absent: rows.filter((r) => !r.hasOverhead),
    unavailable: alfatex.some((r) => !Array.isArray(r.process_costs)) };
}
